module.exports = __webpack_public_path__ + "static/media/admin-user-form-icon.88e48f83.svg";